import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, forkJoin, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationInitService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  /**
   * Initialize translations by preloading common translations
   */
  initTranslations(): Promise<any> {
    const currentLang = this.translateService.currentLang || this.translateService.getDefaultLang() || 'en';
    
    return new Promise((resolve) => {
      // Load common translations directly from the common.json file
      const commonTranslations = this.http.get(`./assets/i18n/${currentLang}/common.json`).pipe(
        catchError(error => {
          console.error(`Failed to load common translations for ${currentLang}:`, error);
          return of({});
        })
      );
      
      forkJoin([commonTranslations]).subscribe(
        ([common]) => {
          // Manually add the translations
          this.translateService.setTranslation(currentLang, common, true);
          resolve(true);
        },
        error => {
          console.error('Failed to load translations:', error);
          resolve(false);
        }
      );
    });
  }
}
